/**
 * ConceptoCobroField (2026-08-31)
 * ----------------------------------------
 * El concepto del cobro con un desplegable DE VERDAD (el datalist de HTML no
 * se despliega en iPhone/Safari y parecía que faltaban opciones) + un campo
 * de texto siempre editable para escribir cualquier otro concepto.
 * Al elegir un concepto con importe fijo, se autorrellena el importe
 * (el caller lo recibe en onChange como segundo argumento).
 */
import React from 'react';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { findCobroConceptPreset, isDevolucionConcept, useCobroPresets } from '../../lib/cobroPresets';

export function ConceptoCobroField({ value, onChange, dataTestid }) {
  // Los atajos son los de Configuración (sin ellos, solo «Devolución»).
  const presets = useCobroPresets();
  return (
    <div className="space-y-1.5">
      <Select
        value=""
        onValueChange={(v) => {
          const preset = findCobroConceptPreset(v, presets);
          onChange(v, preset && preset.amount != null ? String(preset.amount) : null);
        }}
      >
        <SelectTrigger data-testid={dataTestid ? `${dataTestid}-lista` : undefined}>
          <SelectValue placeholder="Elige un concepto de la lista…" />
        </SelectTrigger>
        <SelectContent>
          {presets.map((p) => (
            <SelectItem key={p.value} value={p.value}>
              {p.value}{p.amount != null ? ` — ${p.amount} €` : ''}{p.devolucion ? ' — resta de la caja' : ''}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value, null)}
        placeholder="…o escribe aquí el concepto (editable)"
        data-testid={dataTestid}
      />
      {/* Devolución a mano (2026-09-08): que se vea claro que resta. */}
      {isDevolucionConcept(value) && (
        <p
          className="text-xs rounded bg-amber-50 text-amber-900 border border-amber-200 px-2 py-1.5"
          data-testid={dataTestid ? `${dataTestid}-aviso-devolucion` : undefined}
        >
          Devolución: escribe el importe devuelto en positivo. Se guardará en negativo
          (resta de la caja del mes y del saldo del paciente) y sin IVA.
        </p>
      )}
    </div>
  );
}
